<template>
  <div>
    <div class="footerTop" v-show="footershow">
      <div class="bodyTopMenuL"></div>
      <div class="bodyTopMenu" @click="showFunction()">
        隐藏
        <img src="@/assets/image/menudown.png" style="width:0.46875vw;height:0.4629vh;margin-left:0.15625vw" />
      </div>
      <div class="bodyTopMenuR"></div>

      <div class="bodyTop">
        <div class="rowA">
          <div class="rowAlayout">
            <el-row style="width:100%;">
              <el-col :span="20">
                <img src="@/assets/image/logo1.png" class="showLogo" />
              </el-col>
              <el-col :span="4">
                <img src="@/assets/image/left.png" class="showLeftLogo" />
                <div class="showLeftFont" @click="seeMoreInfo()" style="cursor:pointer">
                  查看更多
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="rowAfont" id="introduction_solid">
            武夷山国家级风景名胜区位于福建省西北部，总面积70平方公里，是国务院首批公布的国家级重点风景名胜区。1999年12月，被联合国教育、科学、文化组织列入《世界遗产名录》。武夷山风景区地质为红色沙砾岩构成的低山丘陵，山峰海拔一般在40咪左右，最高峰三仰峰海拔729.2米。自然风光独树一帜，“三三秀水清如玉的九曲溪，与六六奇峰翠插天空
            武夷山九曲溪景观形象丰富多彩，变 化无穷，凭借-张竹筏顺流而下，即
            可阅尽武夷秀色，此乃武夷山景观的 精华，堪称世界-绝。
          </div>
        </div>
        <div class="rowB">
          <div class="rowBlayout">
            <img src="@/assets/image/logo2.png" style="width:1.197vw;height:1.759vh" />
            <div class="showLeftFont">游武夷山</div>
          </div>
          <div v-for="item in listA" :key="item.key" :class="[
              choosePlayValue == item.key ? 'showTitleColHover' : 'showTitleCol'
            ]" @mouseover="mousePlayEver(item.key)" @mouseout="mousePlayOut()" @click="seeListInfo(item.key)">
            <div class="showTitle">
              {{ item.title }}
            </div>
          </div>
          <div style="position:relative">
            <img src="@/assets/image/logo11.png" class="rightImg" />
          </div>
        </div>

        <div class="rowB">
          <div class="rowBlayout">
            <img src="@/assets/image/logo3.png" style="width:1.197vw;height:1.759vh" />
            <div class="showLeftFont">周边景点</div>
          </div>
          <div v-for="item in listB" :key="item.id" @click="seeInfo(item)" :class="[
              chooseSenceValue == item.id ? 'showTitleColHover' : 'showTitleCol'
            ]" @mouseover="mouseSenceEver(item.id)" @mouseout="mouseSenceOut()">
            <div class="showTitle">{{ item.title }}</div>
          </div>
          <div style="position:relative">
            <img src="@/assets/image/logo12.png" class="rightImgB" />
          </div>
        </div>
        <div class="rowB">
          <div class="rowBlayout">
            <img src="@/assets/image/logo3.png" style="width:1.197vw;height:1.759vh" />
            <div class="showLeftFont">住宿</div>
          </div>
          <div v-for="item in listC" :key="item.key" @click="changeLiveList(item.key)" :class="[
              chooseLiveValue == item.key ? 'showTitleColHover' : 'showTitleCol'
            ]" @mouseover="mouseLiveEver(item.key)" @mouseout="mouseLiveOut(item.key)">
            <div class="showTitle">{{ item.title }}</div>
          </div>
          <div style="position:relative">
            <img src="@/assets/image/logo13.png" class="rightImgC" />
          </div>
        </div>
        <div class="rowB">
          <div class="rowBlayout">
            <img src="@/assets/image/logo4.png" style="width:1.197vw;height:1.759vh" />
            <div class="showLeftFont">餐饮</div>
          </div>
          <div v-for="item in listD" :key="item.key" @click="changeDataList(item.key)" :class="[
              chooseValue == item.key ? 'showTitleColHover' : 'showTitleCol'
            ]" @mouseover="mouseEver(item.key)" @mouseout="mouseOut(item.key)">
            <div class="showTitle">{{ item.title }}</div>
          </div>
          <div style="position:relative">
            <img src="@/assets/image/logo14.png" class="rightImgD" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <div></div> -->
      <div class="bodyCenter">
        <img src="@/assets/image/showUp.png" class="showUpImg" @click="showFunction()" v-show="!footershow" />
      </div>

      <div class="topa">
        <div @click="toCompany()">关于我们</div>
        <div class="left">|</div>
        <div class="left" @click="toCopyright()">免责申明</div>
        <div class="left">|</div>
        <div class="left" @click="toContactUs()">联系我们</div>
        <div class="left">|</div>
        <div class="left" @click="toLink()">友情链接</div>
        <div class="left">|</div>
        <div class="left" @click="kefuOnline()">在线客服</div>
      </div>
      <div class="topb">
         <span> 版权所有 © 福建武夷山旅游发展股份有限公司 未经许可 严禁复制  Copyright © 2022. All Rights Reserved.</span><a style="color:#fff" @click="open()"><span> 闽ICP备12004544</span></a>
         <!-- <div style="text-align:center;margin-top:0.5vh"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getAboutSpot, getAboutSpotById, getLinkList } from "@/api/common";

export default {
  name: "Footer",
  components: {},
  data() {
    return {
      chooseValue: 0,
      chooseLiveValue: 0,
      chooseSenceValue: 0,
      choosePlayValue: 0,
      classNameA: "showTitleCol",
      classNameB: "showTitleCol",
      classNameC: "showTitleCol",
      classNameD: "showTitleCol",
      footershow: false,
      onlineQQ: "",
      listA: [
        { key: 1, title: "散客购票" },
        { key: 2, title: "旅行社购票" },
        { key: 3, title: "武夷山美图" },
        { key: 4, title: "实景漫游" }
      ],
      listB: [],
      listC: [
        { key: 1, title: "星级酒店" },
        { key: 2, title: "经济酒店" },
        { key: 3, title: "特色名宿" }
      ],
      listD: [
        { key: 1, title: "美食推荐" },
        { key: 2, title: "特色餐饮" },
        { key: 3, title: "地道美食" }
      ]
    };
  },
  mounted() {
    var introduction_solid = document.getElementById("introduction_solid");
    var demoHtml = introduction_solid.innerHTML.slice(0, 176) + ".....";
    introduction_solid.innerHTML = demoHtml;
    this.getAboutSpotFunction();
    this.getInfoFunction()
  },
  methods: {
    async getInfoFunction() {
      const { code, data } = await getLinkList();
      if (code == 200) {
        this.onlineQQ = data[2].url;
      }
    },
    mousePlayEver(key) {
      this.choosePlayValue = key;
    },
    mousePlayOut() {
      this.choosePlayValue = 0;
    },
    mouseSenceEver(key) {
      this.chooseSenceValue = key;
    },
    mouseSenceOut() {
      this.chooseSenceValue = 0;
    },
    mouseEver(key) {
      this.chooseValue = key;
    },
    mouseOut() {
      this.chooseValue = 0;
    },
    mouseLiveEver(key) {
      this.chooseLiveValue = key;
    },
    mouseLiveOut() {
      this.chooseLiveValue = 0;
    },
    open(){
      var url = 'https://beian.miit.gov.cn/#/Integrated/recordQuery'
      // window.localtion.href = url
       window.open(url);
    },
    showFunction() {
      this.footershow = !this.footershow;
      this.$emit("footerChange", !this.footershow);
    },
    //美食切换标签
    changeDataList(type) {
      this.footershow = false;
      this.$store.commit("setTabPage", type);
      let name = "TabFood";
      this.$emit("specialtyListFunction", name);
    },
    // 游玩武夷山
    seeListInfo(key) {
      this.footershow = false;
      if (key == 3) {
        this.$emit("specialtyListFunction", "TabBpage");
      }
    },
    //在线客服
    kefuOnline() {
      window.open(`tencent://message/?uin=${this.onlineQQ}`);
    },
    //查看更多
    seeMoreInfo() {
      this.footershow = false;
      this.$emit("specialtyListFunction", "TabApage");
    },
    //公司简介
    toCompany() {
      this.footershow = false;
      this.$emit("specialtyListFunction", "Company");
    },
    toCopyright() {
      this.footershow = false;
      this.$emit("specialtyListFunction", "Copyright");
    },
    toLink() {
      this.footershow = false;
      this.$emit("specialtyListFunction", "Link");
    },
    toContactUs() {
      this.footershow = false;
      this.$emit("specialtyListFunction", "ContactUs");
    },
    //住宿
    changeLiveList(type) {
      this.footershow = false;
      this.$store.commit("setTabPage", type);
      let name = "TabHotel";
      this.$emit("specialtyListFunction", name);
    },
    //景区风景
    async getAboutSpotFunction() {
      const { code, data } = await getAboutSpot(1, 10);
      if (code == 200) {
        this.listB = data.records.slice(0, 3);
        this.total = data.total;
      }
    },
    //景区
    async getAboutSpotByIdFunction(id) {
      const { code, data } = await getAboutSpotById(id);
    },
    //详情
    seeInfo(info) {
      this.footershow = false;
      this.$store.commit("setInfo", info);
      this.getAboutSpotByIdFunction(info.id);
      this.$emit("specialtyListFunction", "SceneryInfo");
    }
  }
};
</script>

<style scoped>
.bodyCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bodyTopMenu {
  font-size: 1.111vh;
  line-height: 2.037vh;
  top: -21.296vh;
  position: absolute;
  z-index: 15;
  width: 4.1667vw;
  height: 2.037vh;
  background: #086057;
  left: 50%;
  margin-left: -2.083vw;
  color: #ffffff;
  text-align: center;
  font-weight: inherit;
}
.bodyTopMenuL {
  top: -21.296vh;
  position: absolute;
  z-index: 15;
  width: 0.5208vw;
  height: 2.037vh;
  /* background: red; */
  left: 50.15%;
  margin-left: -3.125vw;
  color: #ffffff;
  text-align: center;
  border-style: solid;
  border-width: 0.9259vh 0.9259vh 0.9259vh 0.9259vh;
  border-color: transparent #086057 transparent transparent;
}
.bodyTopMenuR {
  top: -21.296vh;
  position: absolute;
  z-index: 15;
  width: 0.9259vh;
  height: 2.037vh;
  /* background: red; */
  left: 50%;
  margin-left: 2.083vw;
  color: #ffffff;
  text-align: center;
  border-style: solid;
  border-width: 0.9259vh 0.9259vh 0.9259vh 0.9259vh;
  border-color: transparent transparent transparent #086057;
}
.mainFooter {
  width: 100%;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footerTop {
  position: relative;
}
.footerTop .bodyTop {
  width: 100%;
  position: absolute;
  z-index: 12;
  bottom: 0px;
  height: 20.833vh;
  background: #30796b;
  border-top: 0.9259vh solid #086057;
  display: flex;
  flex-direction: row;
}
.footerTop .bodyTop .rowA {
  width: 54.159%;
  display: flex;
  flex-direction: column;
}
.footerTop .bodyTop .rowB {
  width: 10.15625vw;
  background: #30796b;
  border-left: 1px solid #086057;
  cursor: pointer;
}

.footerTop .bodyTop .rowAfont {
  width: 93.02%;
  height: 9.074vh;
  font-size: 1.481vh;
  font-family: "Microsoft YaHei";
  font-weight: 300;
  color: #ffffff;
  line-height: 2.7778vh;
  margin: 0px 1.97vw 0px 1.25vw;
  text-overflow: ellipsis;
  /* text-overflow:ellipsis;//超出文本隐藏 */
  overflow: hidden;
  /* white-space: nowrap; */
}

.footerTop .bodyTop .rowA .rowAlayout {
  margin: 2.22vh 1.979vw 1.11vh 1.25vw;
  display: flex;
  flex-direction: row;
}

.footerTop .bodyTop .rowB .rowBlayout {
  margin: 1.6667vh 0px 1.574vh 0.729vw;
  display: flex;
  flex-direction: row;
}
.showTitle {
  margin-left: 0.7291vw;
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  margin-top: 0.555vh;
}
.showTitleCol {
  color: #ffffff;
  position: relative;
  z-index: 13;
}
.showTitleColHover {
  color: #ffa23e;
  position: relative;
  z-index: 13;
}
.footerTop .bodyTop .rowA .showLogo {
  width: 7.65625vw;
  height: 5.833vh;
}
.footerTop .bodyTop .rowA .showLeftLogo {
  width: 0.26vw;
  height: 0.8333vh;
  margin-top: 4.6296vh;
  /* margin-left: 4px; */
  float: right;
  margin-left: 0.10416vw;
  margin-right: 0.5208vw;
}
.footerTop .bodyTop .rowA .showLeftFont {
  font-size: 1.111vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
  line-height: 1.018vh;
  float: right;
  padding-top: 4.629vh;
}
.footerTop .bodyTop .rowB .showLeftFont {
  height: 1.66667vh;
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #ffffff;
  line-height: 1.66667vh;
  padding-left: 0.3645vw;
}

.footer {
  width: 100%;
  height: 8.89vh;
  background: #4a9183;
  border: 1px solid #076c62;
  display: flex;
  flex-direction: column;
  font-size: 1.1111vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #ffffff;
}
.footer .topa {
  display: flex;
  flex-direction: row;
  padding-top: 3.0556vh;
  padding-left: 29.53125vw;
  line-height: 1.2vh;
  cursor: pointer;
}
.footer .topa .left {
  margin-left: 0.52083vw;
}
.footer .topb {
  padding-top: 0.833vh;
  padding-left: 23.95vw;
  line-height: 1.2037vh;
  display: flex;
  flex-direction: row;
}
.showUpImg {
  width: 5.2083vw;
  height: 2.037vh;
  position: absolute;
  z-index: 11;
  cursor: pointer;
}
.rowB .rightImg {
  width: 83.51%;
  height: 11.57vh;
  position: absolute;
  z-index: 11;
  top: -6.0185vh;
  left: 17.01%;
}
.rowB .rightImgB {
  width: 83.51%;
  height: 11.574vh;
  position: absolute;
  z-index: 11;
  top: -3.5185vh;
  left: 17.01%;
}
.rowB .rightImgC {
  width: 88.14%;
  height: 9.351vh;
  position: absolute;
  z-index: 11;
  top: -1.3889vh;
  left: 12.89%;
}
.rowB .rightImgD {
  width: 81.96%;
  height: 7.962vh;
  position: absolute;
  z-index: 11;
  top: 0px;
  left: 17.01%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue